import { render, staticRenderFns } from "./Karin-document.vue?vue&type=template&id=75d79e98"
import script from "./Karin-document.vue?vue&type=script&lang=js"
export * from "./Karin-document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports